import gpCategory from './googleplayCategories'
import appCategory from './appstoreCategories'
import * as _ from 'lodash'

const categories = _.uniq(gpCategory.concat(appCategory));

export default categories;